import { getGlobalEventsLogs, IEvent, createConsumer, createSubscriber } from '@cian/events-log';
import * as React from 'react';

export const useFeedbackForm = () => {
  const feedbackTimeout = React.useRef<number>(null);
  const requestFeedbackForm = React.useCallback(() => {
    const globalLog = getGlobalEventsLogs();

    globalLog.produce('feedback', { type: 'open', value: true });
    feedbackTimeout.current = window.setTimeout(() => {
      window.location.href = '/contacts/';
    }, 50);
  }, []);

  React.useEffect(() => {
    const feedbackConsumer = createConsumer({ topic: 'feedback' });

    const feedbackSubscriber = createSubscriber((event: IEvent<unknown>) => {
      if (event.type === 'popup_opened' && feedbackTimeout.current !== null) {
        window.clearTimeout(feedbackTimeout.current);
      }
    });
    feedbackConsumer.subscribe(feedbackSubscriber);

    return () => {
      feedbackConsumer.unsubscribe(feedbackSubscriber);
      feedbackConsumer.destroy();
      if (feedbackTimeout.current !== null) {
        window.clearTimeout(feedbackTimeout.current);
      }
    };
  });

  return { requestFeedbackForm };
};
